(function ($) {
  'use strict';

  var scriptActive = false;
  var LUX = {};

  function waitForLux(callback) {
    var attempts = 0;
    var maxAttempts = 3;

    function checkLux() {
      if (window.LUX && Object.keys(window.LUX).length > 0) {
        LUX = window.LUX;
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkLux, 1000);
      }
    }

    window.addEventListener('load', checkLux);
  }

  function trackPageLocale() {
    if (!scriptActive) {
      return;
    }

    if (
      window.ys.page_locale === undefined ||
      window.ys.page_locale.length === 0
    ) {
      return;
    }

    LUX.addData('language', window.ys.page_locale);
  }

  function trackPageLabels() {
    if (!scriptActive) {
      console.log('Script not active');
      return;
    }

    if (
      window.ys.page_label === undefined ||
      window.ys.page_label.length === 0
    ) {
      console.log('Window page label not set');
      return;
    }

    console.log('Label succesfully set');
    LUX.label = window.ys.page_label;
  }

  function loadLuxScript() {
    waitForLux(function () {
      scriptActive = true;
      trackPageLocale();
      trackPageLabels();
    });
  }

  loadLuxScript();
}).bind(window)(jQuery);
